
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'customizer-confirm',
    templateUrl: 'customizer-confirm.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class CustomizerConfirmComponent {
	@Input() canOrder: boolean;
	@Output() backEvent = new EventEmitter<boolean>();
	@Output() placeOrderEvent = new EventEmitter<boolean>();

	constructor() { }

	public back() {
		this.backEvent.emit();
	}

	public placeOrder() {
		this.placeOrderEvent.emit();
	}
}
